// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-emergency-contact.page.title': 'Emergency Contacts',
    'team-member-emergency-contact.page.archive.title': 'Archived Emergency Contacts',
    'team-member-emergency-contact.page.search_results': 'Search Results',
    'team-member-emergency-contact.page.create.title': 'Create New Emergency Contact',
    'team-member-emergency-contact.page.search.title': 'Find Emergency Contacts',
    'team-member-emergency-contact.page.edit.title': 'Edit Emergency Contact',
    'team-member-emergency-contact.page.view.title': 'Emergency Contact',
    'team-member-emergency-contact.page.all': 'All',

    'team-member-emergency-contact.button.cancel': 'Cancel',
    'team-member-emergency-contact.button.select': 'Select',
    'team-member-emergency-contact.button.find': 'Find Contacts',
    'team-member-emergency-contact.button.search': 'Apply',
    'team-member-emergency-contact.button.create': 'Save Contact',
    'team-member-emergency-contact.button.new': 'New Contact',
    'team-member-emergency-contact.button.save': 'Save Changes',
    'team-member-emergency-contact.button.archive': 'Archive',
    'team-member-emergency-contact.button.delete': 'Permanently Delete',
    'team-member-emergency-contact.button.edit': 'Edit',
    'team-member-emergency-contact.button.restore': 'Restore',
    'team-member-emergency-contact.button.reset': 'Reset',

    'team-member-emergency-contact.placeholder.search': 'Search emergency contacts',

    'team-member-emergency-contact.link.create_first_team_member_emergency_contact': 'Click here to create your first emergency contact',
    'team-member-emergency-contact.link.team_member_emergency_contacts': ' Return to Emergency Contacts',
    'team-member-emergency-contact.link.archive': 'Archived Emergency Contacts',
    'team-member-emergency-contact.link.retry': 'Click here to retry',

    'team-member-emergency-contact.checkbox.all': 'Check All',
    'team-member-emergency-contact.checkbox.actions_label': 'with selected',

    'team-member-emergency-contact.label.team_member_name': 'Team Member',
    'team-member-emergency-contact.label.title': 'Title',
    'team-member-emergency-contact.label.name': 'Name',
    'team-member-emergency-contact.label.first_name': 'First Name',
    'team-member-emergency-contact.label.last_name': 'Last Name',
    'team-member-emergency-contact.label.relationship': 'Relationship',
    'team-member-emergency-contact.label.email_address': 'Email Address',
    'team-member-emergency-contact.label.telephone': 'Telephone',
    'team-member-emergency-contact.label.mobile': 'Mobile',
    'team-member-emergency-contact.label.address': 'Address',
    'team-member-emergency-contact.label.address_line_1': 'Address Line 1',
    'team-member-emergency-contact.label.address_line_2': 'Address Line 2',
    'team-member-emergency-contact.label.address_line_3': 'Address Line 3',
    'team-member-emergency-contact.label.province': 'Province',
    'team-member-emergency-contact.label.postal_code': 'Postal Code',
    'team-member-emergency-contact.label.country_name': 'Country',

    'team-member-emergency-contact.label.from__created_at': 'From created at',
    'team-member-emergency-contact.label.to__created_at': 'To created at',
    'team-member-emergency-contact.label.created_at': 'Created At',

    'team-member-emergency-contact.label.from__updated_at': 'From updated at',
    'team-member-emergency-contact.label.to__updated_at': 'To updated at',
    'team-member-emergency-contact.label.updated_at': 'Updated At',

    'team-member-emergency-contact.label.from__deleted_at': 'From deleted at',
    'team-member-emergency-contact.label.to__deleted_at': 'To deleted at',
    'team-member-emergency-contact.label.deleted_at': 'Deleted At',

    'team-member-emergency-contact.label.status': 'Status',

    'team-member-emergency-contact.sort.field_label': 'Field',
    'team-member-emergency-contact.sort.direction_label': 'Direction',
    'team-member-emergency-contact.sort.direction_ascending': 'Ascending',
    'team-member-emergency-contact.sort.direction_descending': 'Descending',

    'team-member-emergency-contact.modal.title.team_member_emergency_contact_archive': 'Archive Emergency Contact',
    'team-member-emergency-contact.modal.title.team_member_emergency_contact_delete_permanently': 'Delete Emergency Contact',
    'team-member-emergency-contact.modal.title.team_member_emergency_contact_restore': 'Restore Emergency Contact',

    'team-member-emergency-contact.modal.message.team_member_emergency_contact_archive':
        'Are you sure that you want to move this emergency contact to the archive? | Are you sure that you want to move these emergency contacts to the archive?',
    'team-member-emergency-contact.modal.message.team_member_emergency_contact_delete_permanently':
        'Are you sure that you want to permanently delete this emergency contact? This action cannot be undone. | Are you sure that you want to permanently delete these emergency contacts? This action cannot be undone.',
    'team-member-emergency-contact.modal.message.team_member_emergency_contact_restore': 'Are you sure that you want to restore this emergency contact? | Are you sure that you want to restore these emergency contacts?',

    'team-member-emergency-contact.success.message.team_member_emergency_contact_created': 'Your emergency contact has been created',
    'team-member-emergency-contact.success.message.team_member_emergency_contact_updated': 'Your emergency contact has been updated',
    'team-member-emergency-contact.success.message.team_member_emergency_contact_restored': 'Your emergency contact has been restored | All selected emergency contacts were restored',
    'team-member-emergency-contact.success.message.team_member_emergency_contact_deleted': 'Your emergency contact has been permanently deleted | All selected emergency contacts were permanently deleted',
    'team-member-emergency-contact.success.message.archived_team_member_emergency_contacts': 'Your emergency contact was moved to the archive | All selected emergency contacts were moved to the archive',

    'team-member-emergency-contact.error.message.archived_team_member_emergency_contacts': 'This emergency contact was already moved to the archive | These emergency contacts were already moved to the archive',
    'team-member-emergency-contact.error.message.team_member_emergency_contact_deleted': 'This emergency contact was already permanently deleted | These emergency contacts were already permanently deleted',
    'team-member-emergency-contact.error.message.team_member_emergency_contact_restored': 'This emergency contact was already restored | These emergency contacts were already restored',
    'team-member-emergency-contact.error.message.error_loading_page': 'Sorry, there was an error loading emergency contact.| Sorry, there was an error loading emergency contacts.',

    'team-member-emergency-contact.message.search.no_archived_team_member_emergency_contacts': "You haven't archived any team any member any emergency any contacts as yet.",
};
